var map = {
	"./add-recipient.svg": 747,
	"./alipay.svg": 748,
	"./amex.svg": 749,
	"./app-logout.svg": 750,
	"./arrow.svg": 751,
	"./bank-deposit.svg": 752,
	"./bank.svg": 753,
	"./calculator.svg": 754,
	"./calendar.svg": 755,
	"./check.svg": 756,
	"./checkbox-off.svg": 757,
	"./checkbox-on.svg": 758,
	"./chevron-back.svg": 759,
	"./chevron-down.svg": 760,
	"./close.svg": 761,
	"./cloud.svg": 762,
	"./credit-card.svg": 763,
	"./cross.svg": 764,
	"./default.svg": 765,
	"./delete.svg": 766,
	"./diners.svg": 767,
	"./discover.svg": 768,
	"./done-filled.svg": 769,
	"./download.svg": 770,
	"./e-mail.svg": 771,
	"./edit.svg": 772,
	"./elo.svg": 773,
	"./email-contact.svg": 774,
	"./email-notify.svg": 775,
	"./email.svg": 776,
	"./error.svg": 777,
	"./eye.svg": 778,
	"./facebook.svg": 779,
	"./fail.svg": 780,
	"./file.svg": 781,
	"./follow.svg": 782,
	"./forward.svg": 783,
	"./hipercard.svg": 784,
	"./how-it-works.svg": 785,
	"./image.svg": 786,
	"./info.svg": 787,
	"./information.svg": 788,
	"./instagram.svg": 789,
	"./jcb.svg": 790,
	"./linkedin.svg": 791,
	"./location.svg": 792,
	"./maestro-old.svg": 793,
	"./maestro.svg": 794,
	"./mastercard-old.svg": 795,
	"./mastercard.svg": 796,
	"./media-notify.svg": 797,
	"./money-delivery.svg": 798,
	"./more.svg": 799,
	"./new-recipient.svg": 800,
	"./panding.svg": 801,
	"./paypal.svg": 802,
	"./phone-call.svg": 803,
	"./phone-notify.svg": 804,
	"./phone.svg": 805,
	"./post-notify.svg": 806,
	"./post.svg": 807,
	"./present.svg": 808,
	"./present_deactive.svg": 809,
	"./process.svg": 810,
	"./profile.svg": 811,
	"./recipients.svg": 812,
	"./refresh.svg": 813,
	"./search.svg": 814,
	"./security-code.svg": 815,
	"./security.svg": 816,
	"./settings.svg": 817,
	"./sms-notify.svg": 818,
	"./sms.svg": 819,
	"./success.svg": 820,
	"./support.svg": 821,
	"./transaction-list.svg": 822,
	"./transfer-money.svg": 823,
	"./twitter.svg": 824,
	"./uk.svg": 825,
	"./unionpay.svg": 826,
	"./users.svg": 827,
	"./verve.svg": 828,
	"./visa.svg": 829,
	"./waiting.svg": 830,
	"./warning.svg": 831,
	"./zoom.svg": 832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 746;